const linkResolver = (doc) => {
  // URL for a category type
  if (doc.type === "blog") {
    return `/blog/${doc.uid}`;
  }

  // Return null for unmatched routes to allow 404 page
  return null;
};
export default linkResolver;